// src/App.js
import { Routes, Route, Link, useLocation, Navigate } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ChartStudioPage from "./pages/ChartStudioPage.tsx";
import AdminPromoManagerPage from "./pages/AdminPromoManagerPage.tsx";
import MainLayout from "./layouts/MainLayout";
import UnlockPage from "./pages/UnlockPage.tsx";
import homepageContent from "./content/homepageContent.en.json";
import AdminPromo from "./pages/AdminPromo.tsx";
import PlanFeaturesPage from "./pages/PlanFeaturesPage.tsx";


import "./styles/ui-foundation.css";
import "./styles/phase3-guidance.css";

function App() {
  const routerLocation = useLocation();
  const launchMode = Boolean(homepageContent?.launch_mode);

  return (
    <>
      {/* Sticky Header */}
      <header
        style={{
          position: "sticky",
          top: 0,
          zIndex: 50,

          background:
            routerLocation.pathname === "/"
              ? "rgba(2,6,23,0.78)"
              : "rgba(2,6,23,0.92)",

          borderBottom: "1px solid rgba(148,163,184,0.12)",
        }}
      >
        <div
          style={{
            maxWidth: 1200,
            margin: "0 auto",
            padding: "6px 20px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Link
            to="/"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              textDecoration: "none",
              color: "#e5e7eb",
              fontSize: 13,
              fontWeight: 700,
            }}
          >
            <span>
              SysMind<span className="brand-x">X</span> Astro</span>
          </Link>
          

          {/* Back link (only show when NOT on home) */}
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
  
    <div className="back-link">
      <Link
            to="https://sysmindx.com"
            target="_blank"
            rel="noopener noreferrer"
      style={{ fontSize: 14, color: "#9ca3af", textDecoration: "none"}}>
        SysMindX <img src="/external-linky.png" alt="Company" color="#9ca3af" width={18} height={18}/>
      </Link>
    </div>
  

  {/* Language Toggle — homepage only */}
  {routerLocation.pathname === "/" && (
    <div style={{ display: "flex", gap: 8 }}>
      <button
        type="button"
        onClick={() => localStorage.setItem("sx_lang", "en") || window.location.reload()}
        style={{
          fontSize: 12.5,
          padding: "6px 10px",
          borderRadius: 999,
          border: "1px solid rgba(148,163,184,0.18)",
          background: "rgba(255,255,255,0.03)",
          color: "#e5e7eb",
          cursor: "pointer",
        }}
      >
        EN
      </button>

      <button
        type="button"
        onClick={() => localStorage.setItem("sx_lang", "hi") || window.location.reload()}
        style={{
          fontSize: 12.5,
          padding: "6px 10px",
          borderRadius: 999,
          border: "1px solid rgba(148,163,184,0.18)",
          background: "rgba(255,255,255,0.03)",
          color: "#e5e7eb",
          cursor: "pointer",
        }}
      >
        हिंदी
      </button>
    </div>
  )}
</div>

        </div>
      </header>

      {/* Routes */}
      <Routes>
        <Route
          path="/"
          element={
            <MainLayout>
              <HomePage />
            </MainLayout>
          }
        />

        {/* If launchMode = true, block /chart completely */}
        <Route
          path="/chart"
          element={
            launchMode ? (
              <Navigate to="/" replace />
            ) : (
              <MainLayout>
                <ChartStudioPage />
              </MainLayout>
            )
          }
        />
       {/* Hidden Admin Route (Phase-8B JWT Promo Manager) */}
        <Route
          path="/admin/promo-manager"
          element={
            <MainLayout>
              <AdminPromoManagerPage />
            </MainLayout>
          }
        />

        <Route path="/unlock" element={<UnlockPage />} />
        
        <Route path="/plan-features" element={<PlanFeaturesPage />} />

        <Route path="/admin/promo" element={<AdminPromo />} />

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
